import { theme } from '@acorns/web-components'
import styled from 'styled-components'

import { RECAP_XS_BREAKPOINT } from '../../styles'

export const CarouselContainer = styled.div`
  display: flex;
  overflow-y: auto;
  padding-left: 70px;
  position: relative;

  /* Must split right padding to :after to work with Safari */
  &:after {
    content: '';
    display: block;
    padding-right: 70px;
  }

  /* Only target FireFox */
  @supports (-moz-appearance: none) {
    &:after {
      display: none;
    }
  }

  @media screen and (max-width: ${theme.breakpoints.md}px) {
    padding-left: 50px;

    &:after {
      padding-right: 50px;
    }
  }

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    padding-left: 30px;

    &:after {
      padding-right: 30px;
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`

interface Props {
  backgroundColor: string
}

export const CardContainer = styled.div<Props>`
  background-color: ${(props) => props.backgroundColor};
  border-radius: ${theme.borderRadius.large};
  flex-basis: 180px;
  flex-grow: 0;
  flex-shrink: 0;
  height: 275px;
  margin-right: 20px;
  padding: 20px;
  width: 180px;

  &:last-child {
    margin-right: 0;
  }
`

export const CardIndex = styled.span`
  background-color: ${theme.colors.white};
  border-radius: 100px;
  color: ${theme.colors.slate};
  display: block;
  font-family: 'Avenir Next';
  font-size: 16px;
  font-weight: 600;
  height: 30px;
  letter-spacing: 0px;
  line-height: 24px;
  margin-bottom: 20px;
  padding: 4px;
  text-align: center;
  width: 30px;
`

export const CardTitle = styled.h3`
  color: ${theme.colors.white};
  font-family: 'Avenir Next';
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0px;
  margin-bottom: 5px;
`

export const CardContent = styled.p`
  color: ${theme.colors.white};
  font-family: Avenir Next;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 22px;
  margin: 0;
`
